import { Injectable } from '@angular/core';
export class SwipeService {
private swipeCoord?: [number, number];
private swipeTime?: number;
/**
 * \@description detect the direction of the swipe, and return a -1 or 1 if the duration is long enough
 *              else return a 0 to do nothing
 * @param {?} e
 * @param {?} when
 * @param {?=} debug
 * @return {?}
 */
swipe(e: TouchEvent, when: string, debug?: boolean): number {
    if (debug === true) console.log(`SwipeService::swipe(${ e }, ${ when })`);
    const /** @type {?} */ coord: [number, number] = [e.changedTouches[0].pageX, e.changedTouches[0].pageY];
    const /** @type {?} */ time = new Date().getTime();

    if (when === 'start') {
      this.swipeCoord = coord;
      this.swipeTime = time;
    }

    else if (when === 'end') {
      const /** @type {?} */ direction = [coord[0] - this.swipeCoord[0], coord[1] - this.swipeCoord[1]];
      const /** @type {?} */ duration = time - this.swipeTime;

      if (duration < 1000 // Short enough
        && Math.abs(direction[1]) < Math.abs(direction[0]) // Horizontal enough
        && Math.abs(direction[0]) > 30) {  // Long enough
        return direction[0] < 0 ? 1 : -1;
      }
    }

    return 0;
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function SwipeService_tsickle_Closure_declarations() {
/** @type {?} */
SwipeService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
SwipeService.ctorParameters;
/** @type {?} */
SwipeService.prototype.swipeCoord;
/** @type {?} */
SwipeService.prototype.swipeTime;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
